<template>
<div
  class="landing-page-wrapper"
  >
  <div
    class="landing-page-part"
    :class="{
      scrollImage,
      rightAlignImage,
      leftAlignImage
    }"
    :style="`background-image: url(${imageUrl});`"
    />

  <img
    v-if="banner !== ''"
    class="landing-page__banner"
    :src="banner"
    />

  <div
    class="landing-page__content__wrapper"
    >
    <div
      class="landing-page__content"
      :class="{ rightAlign }"
    >
      <img v-if="deviceImage === true"
        :src="require('@/assets/device.png')"
        />

      <h1 :id="title"
        v-html="title"
        />
      <div
        class="landing-page__content__copy"
        >
        <p :class="{ lightText }" v-html="copy" />
        <download-app v-if="appLink" />
      </div>

      <signup-form v-if="signup"/>
    </div>
  </div>
</div>
</template>
<script>

import SignupForm from '@/components/elements/SignupForm.vue'
import DownloadApp from '@/components/landingPage/DownloadApp.vue'

export default {
  components: { SignupForm, DownloadApp },
  props: {
    rightAlignImage: {
      type: Boolean,
      default: false
    },
    appLink: {
      type: Boolean,
      default: false
    },
    leftAlignImage: {
      type: Boolean,
      default: false
    },
    rightAlign: {
      type: Boolean,
      default: false
    },
    lightText: {
      type: Boolean,
      default: false
    },
    scrollImage: {
      type: Boolean,
      default: false
    },
    deviceImage: {
      type: Boolean,
      default: false
    },
    signup: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    copy: {
      type: String,
      default: ''
    },
    imageUrl: {
      type: String,
      default: ''
    },
    banner: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  .landing-page-wrapper {
    position: relative;
    height: auto;
    width: 100%;
    overflow-x: hidden;
    box-shadow: @shadow;

    @media (max-width: @width-max) {
      p {
        color: @color-font-dark !important;
      }
    }
  }

  .landing-page-part {
    position: relative;
    height: 100vh;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: 40px;
    background-size: cover;
    background-attachment: fixed;
    display: flex;
    justify-content: center;

    @media (max-width: @width-max) {
      background-attachment: scroll;
      background-position-y: 0px;
      height: 50vw;
      width: 100vw;
      background-size: fill;
    }
  }

  .landing-page__content__wrapper {
    position: absolute;
    display: flex;
    top: 0px;
    bottom: 0px;
    justify-content: center;
    flex-direction: column;
    align-self: center;
    box-sizing: border-box;
    height: auto;
    width: 100%;
    overflow: visible;

    @media (max-width: @width-max) {
      position: relative;
      top: 0px;
      padding: 20px;
    }
  }

  .landing-page__content {
    position: relative;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    align-self: center;
    max-width: @width-max;
    height: auto;
    width: 100%;
    box-sizing: border-box;
    background-color: transparent;

    &__copy {
      width: 40%;

      @media (max-width: @width-max) {
        width: 100%;
      }
    }

    h1 {
      width: 100%;
    }

    h1, p {
      text-shadow: 0px 5px 35px rgba(0, 0, 0, 0.12);

      @media (max-width: @width-max) {
        width: 100%;
      }
    }
  }

  .landing-page__banner {
    position: absolute;
    top: 20px;
    left: 50%;
    width: 250px;
    height: auto;
    transform: translateX(100px);
    box-shadow: @shadow;
    border-radius: 3px;

    @media (max-width: 730px) {
      transform: none;
      left: auto;
      right: 10px;
    }

    @media (max-width: 590px) {
      transform: none;
      left: 10px;
      right: auto;
    }

    @media (max-width: 500px) {
      width: 50%;
      top: 10px;
    }
  }

  .rightAlign {
    align-items: flex-end !important;

    h1 {
      text-align: right;

      @media (max-width: @width-max) {
        text-align: left;
      }
    }
  }

  .lightText {
    color: @color-font-light !important;
  }

  .scrollImage {
    background-attachment: scroll !important;
    background-position-y: 0px;
  }

  .rightAlignImage {
    background-position-x: right;
  }

  .leftAlignImage {
    background-position-x: left;
  }
</style>
